export const sidebarMenuList = {
    assets: 'assets',
    trade: 'tradeCenter',
    wallet: 'walletQuota',
    setting: 'setting'
};
export const secondMenuList = {
    assets: [ 'viteExplorer', 'viteScanExplorer' ],
    trade: [ 'tradeCenter', 'tradeOpenOrders', 'tradeOrderHistory', 'tradeMining', 'tradeDividend' ],
    wallet: [ 'walletQuota', 'walletVote', 'walletFullNode', 'walletSBP', 'walletMintage', 'walletTransList' ]
};
